import { initPage } from './init';

document.addEventListener('DOMContentLoaded', () => {
  // initialise variables
  const main = document.querySelector('#main');
  const filters = document.querySelectorAll('.filter');
  let showFilters = true;
  let currentPage = 1;
  const currentPageEl = document.querySelector('[data-filter-param-page]');
  if (currentPageEl) {
    currentPage = parseInt(currentPageEl.value);
  }
  let fetchPage = currentPage;
  let isFetch = false;
  let updateUrl = true;
  const urlBase = window.location.pathname.startsWith('/sale')
    ? '/sale/'
    : '/products/';

  // dev log
  function devLog(msg) {
    console.log(msg);
  }

  // filter the products
  function filter(loadType = 'replace', scrollY = null) {
    // reset the page if replacing the results
    if (loadType === 'replace') {
      updatePage(1);
      fetchPage = 1;
    }

    // init
    const params = {};
    const queryParams = {};

    // loop through all filters and find the selected checkbox and log it
    document
      .querySelectorAll(
        '[data-filter-param-checked]:checked, [data-filter-param-input]'
      )
      .forEach((checked) => {
        params[checked.name] = checked.value;
      });

    // loop through all filters and find the selected query and log it
    document.querySelectorAll('[data-filter-param-query]').forEach((query) => {
      if (query.name === 'page' && query.value === '1') {
        return;
      }
      queryParams[query.name] = query.value;
    });

    // if fetching the previous page, update the page number
    if (isFetch) {
      queryParams.page = fetchPage;
      isFetch = false;
      updateUrl = false;
    }

    // remove invalid categories
    if (params.subCategory && (!params.category || !params.primary)) {
      delete params.subCategory;
    }
    if (params.category && !params.primary) {
      delete params.category;
    }

    // build the url and load it
    const url = buildUrl(params, queryParams);
    loadUrl('products', url, loadType, updateUrl, scrollY);
    updateUrl = true;
  }

  // build the url
  function buildUrl(params, queryParams) {
    // init
    let url = urlBase;

    // loop through the params
    Object.keys(params).forEach((key) => {
      if (urlBase === '/sale/' && key === 'saleCategory') {
        url += `${params[key]}/`;
        return;
      }

      if (urlBase === '/sale/' && key === 'sale') {
        return;
      }

      if (
        key !== 'primary' &&
        key !== 'category' &&
        key !== 'subCategory' &&
        key !== 'sale'
      ) {
        url += `${key}/`;
      }
      url += `${params[key]}/`;
    });

    // loop through the query params
    if (Object.keys(queryParams).length > 0) {
      url += '?';
    }
    let sep = '';
    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] || queryParams[key].length) {
        url += sep + `${key}=${queryParams[key]}`;
        sep = '&';
      }
    });

    // remove the trailing ? if it exists
    if (url.endsWith('?')) {
      url = url.slice(0, -1);
    }

    console.log(url);

    return url;
  }

  // load the url
  function loadUrl(
    id,
    url,
    loadType = 'replace',
    updateUrl = true,
    scrollY = null
  ) {
    // add loading class
    document
      .querySelector('[data-filter-id="' + id + '"]')
      .classList.add('is-loading');

    // parse url with ajax flag
    let parsedUrl = url;
    if (loadType !== 'replace') {
      if (url.indexOf('?') !== -1) parsedUrl += '&ajax=1';
      else parsedUrl += '?ajax=1';
    }

    // fetch the url
    fetch(parsedUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // push state
        if (updateUrl) {
          const title = doc.querySelector('title').textContent;
          window.history.pushState(
            {
              id: 'products',
            },
            title,
            url
          );
          document.title = title;
        }

        // update results
        if (loadType === 'replace') {
          document.querySelector(
            '[data-filter-id="' + id + '"] [data-filter-results]'
          ).innerHTML = doc.querySelector(
            '[data-filter-id="' + id + '"] [data-filter-results]'
          ).innerHTML;
        } else if (loadType === 'after') {
          document.querySelector(
            '[data-filter-id="' + id + '"] [data-filter-results]'
          ).innerHTML =
            document.querySelector(
              '[data-filter-id="' + id + '"] [data-filter-results]'
            ).innerHTML +
            doc.querySelector(
              '[data-filter-id="' + id + '"] [data-filter-results]'
            ).innerHTML;
        } else if (loadType === 'before') {
          document.querySelector(
            '[data-filter-id="' + id + '"] [data-filter-results]'
          ).innerHTML =
            doc.querySelector(
              '[data-filter-id="' + id + '"] [data-filter-results]'
            ).innerHTML +
            document.querySelector(
              '[data-filter-id="' + id + '"] [data-filter-results]'
            ).innerHTML;
        }

        // Loop through all [data-filter-dynamic], and for each, find its counterpart in the newly loaded doc.
        document
          .querySelectorAll(
            '[data-filter-id="' + id + '"] [data-filter-dynamic]'
          )
          .forEach((el) => {
            const dyn = el.getAttribute('data-filter-dynamic');
            // find corresponding element in doc
            const newEl = doc.querySelector(
              '[data-filter-id="' +
                id +
                '"] [data-filter-dynamic="' +
                dyn +
                '"]'
            );
            if (newEl) {
              // If this is a filter element, optionally preserve open/closed state if newEl is enabled
              if (el.classList.contains('filter')) {
                const wasOpen = el.classList.contains('filter--open');
                const wasClosed = el.classList.contains('filter--closed');
                const newIsEnabled =
                  newEl.classList.contains('filter--enabled');
                const hasCheckedInput =
                  newEl.querySelector('[data-filter-param-checked]:checked') !==
                  null;
                // replace content and classes as normal, but keep open/closed if newEl is enabled
                el.innerHTML = newEl.innerHTML;
                el.className = newEl.className;
                if (newIsEnabled) {
                  if (hasCheckedInput) {
                    el.classList.add('filter--open');
                    el.classList.remove('filter--closed');
                  } else if (
                    wasOpen &&
                    !el.classList.contains('filter--open')
                  ) {
                    el.classList.add('filter--open');
                    el.classList.remove('filter--closed');
                  } else if (
                    wasClosed &&
                    !el.classList.contains('filter--closed')
                  ) {
                    el.classList.add('filter--closed');
                    el.classList.remove('filter--open');
                  }
                }
              } else {
                el.innerHTML = newEl.innerHTML;
                el.className = newEl.className;
              }
              el.hidden = newEl.hidden;
            }
          });

        // init and update the page
        init();
        update();

        // remove loading class
        document
          .querySelector('[data-filter-id="' + id + '"]')
          .classList.remove('is-loading');

        // scroll to top if replacing the results (delay by 10ms)
        if (loadType === 'replace') {
          setTimeout(() => {
            const scrollTop = document.querySelector(
              '[data-browse-header-scroll]'
            ).offsetTop;
            scrollTo(scrollTop, 'smooth');
            console.log('scrolled to top');
            console.log(scrollTop);
          }, 10);
        }

        // scroll to top if specified
        if (scrollY) {
          // scrollTo(scrollY, 'instant');
        }
      })
      .catch(function (err) {
        devLog('Failed to fetch page: ', err);

        // remove loading class
        document
          .querySelector('[data-filter-id="' + id + '"]')
          .classList.remove('is-loading');
      });
  }

  // scroll wrapper function
  function scrollTo(y, behavior = 'smooth') {
    const main = document.querySelector('#main');
    const siteHeader = document.querySelector('.site-header');

    main.classList.add('is-programmatic-scroll');
    if (main.classList.contains('is-menu-open') !== true) {
      main.classList.remove('is-menu-compacted');
    }

    if (siteHeader) {
      y -= siteHeader.offsetHeight;
    }

    window.scrollTo({ top: y, behavior });

    const finishProgrammaticScroll = () => {
      if (!main.classList.contains('is-programmatic-scroll')) return;
      main.classList.remove('is-programmatic-scroll');
      window.dispatchEvent(new CustomEvent('scroll'));
    };

    if (behavior === 'instant') {
      finishProgrammaticScroll();
      return;
    }

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      window.removeEventListener('scrollend', finish);
      clearTimeout(fallbackTimer);
      finishProgrammaticScroll();
    };

    window.addEventListener('scrollend', finish, { once: true });
    const fallbackTimer = setTimeout(finish, 1000);
  }

  // toggle filters
  function toggleFilters() {
    // toggle the show filters
    showFilters = !showFilters;

    // update button text
    document.querySelectorAll('[data-filters-toggle] > span').forEach((el) => {
      el.textContent = !showFilters ? 'Show Filters' : 'Hide Filters';
    });

    // hide/show the filters
    document.querySelectorAll('[data-filters]').forEach((el) => {
      el.hidden = !showFilters;
    });

    // ensure card columns are adjusted for width
    document
      .querySelector('[data-browse]')
      .classList.toggle('browse--filters-hidden', !showFilters);
    document
      .querySelector('[data-browse]')
      .classList.toggle('browse--filters-visible', showFilters);
  }

  // toggle overlay filters
  function toggleOverlayFilters() {
    main.classList.toggle('is-filters-visible');
  }

  // change filter
  function changeFilter(el) {
    // Uncheck all other checkboxes in the same filter
    const currentInput = el;
    if (currentInput.type === 'checkbox') {
      const filterContainer = currentInput.closest('.filter');
      if (filterContainer) {
        filterContainer
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            if (input !== currentInput) {
              input.checked = false;
            }
          });
      }
    }

    // Also remove child categories if a parent category is changed
    if (
      currentInput.name === 'saleCategory' ||
      currentInput.name === 'primary' ||
      currentInput.name === 'category'
    ) {
      const childFilterIds =
        currentInput.name === 'saleCategory' || currentInput.name === 'primary'
          ? ['category', 'subCategory']
          : ['subCategory'];

      childFilterIds.forEach((filterId) => {
        const filterContainer = document.querySelector(
          `.filter[data-id="${filterId}"]`
        );
        if (filterContainer) {
          filterContainer
            .querySelectorAll('input[type="checkbox"]')
            .forEach((input) => {
              if (input !== currentInput) {
                input.checked = false;
              }
            });
        }
      });
    }

    // filter the products
    filter();
  }

  // clear filter
  function clearFilter(handle) {
    document.querySelectorAll(`input[name="${handle}"]`).forEach((input) => {
      input.checked = false;
    });

    // filter the products
    filter();
  }

  // clear all filters
  function clearFilters() {
    // remove all filters
    document
      .querySelectorAll(
        '[data-filter-param-checked]:checked, [data-filter-param-input]'
      )
      .forEach((input) => {
        input.checked = false;
      });

    // remove all query params
    document.querySelectorAll('[data-filter-param-query]').forEach((query) => {
      query.value = '';
    });

    // filter the products
    filter();
  }

  // load more
  function loadMore() {
    // get offset y of the last card
    const cards = document.querySelectorAll(
      '[data-filter-id="products"] [data-filter-results] .card:not(.card--promo)'
    );
    let loadMoreY = null;
    if (cards.length > 0) {
      const lastCard = cards[cards.length - 1];
      loadMoreY = lastCard.getBoundingClientRect().top + window.scrollY;
    }
    const browseHeader = document.querySelector('[data-browse-header]');
    if (browseHeader) {
      loadMoreY -= browseHeader.offsetHeight;
    }

    scrollTo(loadMoreY, 'smooth');

    updatePage(currentPage + 1);

    filter('after', loadMoreY);
  }

  // load prev
  function loadPrevious() {
    fetchPage--;
    isFetch = true;

    filter('before');
  }

  // update page
  function updatePage(page) {
    currentPage = page;

    // update the page number element
    document.querySelectorAll('[data-filter-param-page]').forEach((page) => {
      page.value = currentPage;
    });
  }

  // update page elements
  function update() {
    // update the product count
    document.querySelectorAll('[data-filter-count]').forEach((el) => {
      el.textContent = document.querySelectorAll(
        '[data-filter-id="products"] [data-filter-results] .card:not(.card--promo)'
      ).length;
    });

    // update the load more bar count
    document.querySelectorAll('[data-filter-bar]').forEach((el) => {
      el.style.setProperty(
        '--load-more-bar-count',
        document.querySelector('[data-filter-count]').textContent
      );
    });

    // hide the load previous button if on the first page
    if (fetchPage === 1) {
      document
        .querySelectorAll('[data-filter-dynamic="load-prev"]')
        .forEach((el) => {
          el.style.display = 'none';
        });
    }

    // show the load more button if there are more products
    const totalEl = document.querySelector('[data-filter-total]');
    const countEl = document.querySelector('[data-filter-count]');
    const total = totalEl ? parseInt(totalEl.textContent) : 0;
    const count = countEl ? parseInt(countEl.textContent) : 0;
    if (total > count) {
      document
        .querySelectorAll('[data-filter-dynamic="load-more"]')
        .forEach((el) => {
          el.style.display = 'flex';
        });
    } else {
      document
        .querySelectorAll('[data-filter-dynamic="load-more"]')
        .forEach((el) => {
          el.style.display = 'none';
        });
    }
  }

  function init() {
    // open/close filters
    filters.forEach((filter) => {
      const head = filter.querySelector('.filter__head');
      const body = filter.querySelector('.filter__body');

      head.addEventListener('click', () => {
        filter.classList.toggle('filter--open');
      });
    });

    // listen for clicks on the checkbox filter items
    document.querySelectorAll('[data-filter-change]').forEach((el) => {
      el.addEventListener('change', () => {
        changeFilter(el);
      });
    });

    // clear filter
    document.querySelectorAll('[data-filter-clear]').forEach((el) => {
      el.addEventListener('click', () => {
        clearFilter(el.getAttribute('data-filter-clear'));
      });
    });

    // clear all filters
    document.querySelectorAll('[data-filters-clear]').forEach((el) => {
      el.addEventListener('click', () => {
        clearFilters();
      });
    });

    // load more
    document.querySelectorAll('[data-load-more]').forEach((el) => {
      el.addEventListener('click', () => {
        loadMore();
      });
    });

    // load previous
    document.querySelectorAll('[data-load-prev]').forEach((el) => {
      el.addEventListener('click', () => {
        loadPrevious();
      });
    });

    // toggle filters overlay
    document.querySelectorAll('[data-filters-overlay-toggle]').forEach((el) => {
      if (!el._overlayClickListenerAdded) {
        el.addEventListener('click', () => {
          toggleOverlayFilters();
        });
        el._overlayClickListenerAdded = true;
      }
    });

    // init page
    initPage();
  }

  init();

  // toggle filters
  document.querySelectorAll('[data-filters-toggle]').forEach((el) => {
    el.addEventListener('click', () => {
      toggleFilters();
    });
  });
});
